import type { FC } from "react";
import { DateInput } from "../date-input";

import type { InputProps } from "~/utils/types";
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "../ui/form";

const DateFormInput: FC<Props> = ({ name, label, helperText, type, tabIndex }) => {
  return (
    <FormField
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <DateInput
              tabIndex={tabIndex}
              type={type}
              value={field.value}
              onChange={(e) => {
                field.onChange(e);
              }}
            />
          </FormControl>
          {helperText && <FormDescription>{helperText}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export { DateFormInput };

interface Props extends InputProps {
  type: "daytime" | "date";
  tabIndex?: number;
}
